export default "__VITE_ASSET___JqBeJsI__"